import { render } from "./XTaskNode.vue?vue&type=template&id=4769f08a&scoped=true"
import script from "./XTaskNode.vue?vue&type=script&lang=js"
export * from "./XTaskNode.vue?vue&type=script&lang=js"

import "./XTaskNode.vue?vue&type=style&index=0&id=4769f08a&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.33_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4769f08a"]])

export default __exports__